<template class="pendencyBody">
    <div>
        <div>
            <CustomLoader v-if="isLoading" :width="70" />
        </div>

        <b-card class="mainCardBG">
            <b-row>
                <b-navbar-nav>

                </b-navbar-nav>

                <b-col md="2">
                    <h5 class="page-title mb-2">
                        <b>{{ $route.name }}</b>
                    </h5>
                </b-col>

            </b-row>

            <div class="mt-3">
                <!-- Search Form Input Start -->
                <b-row>
                    <b-col md="6" class="my-1">
                        <b-form-group>
                            <b-input-group>
                                <b-form-input :formatter="capitalizeAll" @input="debounceSearch"
                                    v-model="Filter.commonFilter" placeholder="Type to Search Assignment"
                                    ref="search" />
                                <b-input-group-append class="mr-1">
                                    <b-button :disabled="!Filter.commonFilter" @click="filterClear">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>

                            <b-col md="3">

                            </b-col>
                        </b-form-group>
                    </b-col>

                    <b-col md="5">

                        <b-button class="pull-right ml-1" :variant="Filter.userFilter ||
                            Filter.lomInvNoFilter ||
                            Filter.lom_ledger_nameFilter ||
                            Filter.lom_doc_typeFilter ||
                            Filter.lom_gst_noFilter ||
                            Filter.lom_pan_noFilter ||
                            Filter.lom_comp_nameFilter ||
                            Filter.lom_ref_typeFilter ||
                            Filter.lom_reference_noFilter ||
                            Filter.lom_doc_dateFilter ||
                            Filter.isActiveFilter ||
                            Filter.commonFilter ||
                            Filter.clientIdFilter ||
                            Filter.createdAtRange.startDate ||
                            Filter.createdAtRange.endDate
                            ? 'outline-danger'
                            : 'outline-primary'
                            " :class="' pull-right mb-1' + visible ? null : 'collapsed'"
                            :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                            @click="visible = !visible" style="font-size: 0.675rem">{{
                                Filter.userFilter ||
                                    Filter.lomInvNoFilter ||
                                    Filter.lom_ledger_nameFilter ||
                                    Filter.lom_doc_typeFilter ||
                                    Filter.lom_gst_noFilter ||
                                    Filter.lom_pan_noFilter ||
                                    Filter.lom_comp_nameFilter ||
                                    Filter.lom_ref_typeFilter ||
                                    Filter.lom_reference_noFilter ||
                                    Filter.lom_doc_dateFilter ||
                                    Filter.isActiveFilter ||
                                    Filter.commonFilter ||
                                    Filter.clientIdFilter ||
                                    Filter.createdAtRange.startDate ||
                                    Filter.createdAtRange.endDate
                                    ? "Filter ON"
                                    : "Filter OFF"
                            }}</b-button>

                        <b-button class="pull-right mb-1" v-if="OutstandingList.length > 0"
                            :disabled="ExcelBtnName !== 'Export As Excel'"
                            @click="getReports('checkJobPendency', 'Export As Excel')" size="sm" variant="warning"
                            style="font-size: 0.675rem">
                            {{ ExcelBtnName }}
                            <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small
                                label="Small Spinner"></b-spinner>
                        </b-button>
                        <userBasedClient v-if="$sessionsStorage.get('userId')"
                            :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')"
                            :PMC_USERID="Filter.userFilter" :PMC_USERNAME="$sessionsStorage.get('nameUser')"
                            :PMC_USERDESIG="$sessionsStorage.get('designation')"
                            :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
                            :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
                            :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
                            :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
                    </b-col>

                    <b-col md="1">
                        <h5>
                            <small v-if="!isLoading">{{ totalData }} Entries</small>
                        </h5>
                    </b-col>
                </b-row>

                <div v-if="visible">
                    <b-card>
                        <b-collapse v-model="visible" id="collapse-2">
                            <b-row>
                                <b-col md="3">
                                    <label>Date</label>
                                    <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                                        @update="getOutstandingList('Normal', '0', '0', '1', '1')"></date-range-picker>
                                </b-col>
                                <b-col md="3">
                                    <label>User</label>
                                    <model-list-select :list="$store.getters['common/getAllUserList']"
                                        id="addedUserFilter" @input="debounceSearch" v-model="Filter.userFilter"
                                        option-value="userId" option-text="employeeName"
                                        placeholder="Select Created User" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lomInvNoFilter">Inv No</label>
                                    <b-form-input id="lomInvNoFilter" type="text" @input="debounceSearch"
                                        v-model="Filter.lomInvNoFilter" />
                                </b-col>

                                <b-col cols="3">
                                    <label for="lom_ledger_nameFilter">Ledger Name</label>
                                    <b-form-input id="lom_ledger_nameFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_ledger_nameFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_doc_typeFilter">Doc Type</label>
                                    <b-form-input id="lom_doc_typeFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_doc_typeFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_gst_noFilter">GST No</label>
                                    <b-form-input id="lom_gst_noFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_gst_noFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_pan_noFilter">PAN No</label>
                                    <b-form-input id="lom_pan_noFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_pan_noFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_comp_nameFilter">Company Name</label>
                                    <b-form-input id="lom_comp_nameFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_comp_nameFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_ref_typeFilter">Ref. Type</label>
                                    <b-form-input id="lom_ref_typeFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_ref_typeFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_reference_noFilter">Ref. No</label>
                                    <b-form-input id="lom_reference_noFilter" @input="debounceSearch" type="text"
                                        v-model="Filter.lom_reference_noFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="lom_doc_dateFilter">Doc Date</label>
                                    <b-form-input id="lom_doc_dateFilter" @input="debounceSearch" type="date"
                                        v-model="Filter.lom_doc_dateFilter" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="isActiveFilter">Status</label>
                                    <model-list-select @input="debounceSearch" :list="listStatus" id="isActiveFilter"
                                        v-model="Filter.isActiveFilter" option-value="value" option-text="label"
                                        placeholder="Select Status" />
                                </b-col>
                                <b-col cols="3">
                                    <label for="isActiveFilter">Client</label>
                                    <model-list-select @input="debounceSearch"
                                        :list="$store.getters['common/getAllClientList']" id="clientfilter"
                                        v-model="Filter.clientIdFilter" option-value="clientId" option-text="clientName"
                                        placeholder="Select Client">
                                    </model-list-select>
                                </b-col>

                                <b-col md="12" class="mt-2">
                                    <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right"
                                        @click="clearFilter" variant="outline-danger">Reset</b-button>
                                </b-col>
                            </b-row>
                        </b-collapse>
                    </b-card>
                </div>
                <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                    :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
                <div class="col-md-12 row ">

                    <b-table show-empty stacked="md" responsive :fields="columnMain" :items="OutstandingList"
                        class="table-background position-relative" :per-page="pagination.perPage" :filter="filter"
                        @filtered="onFiltered">
                        <!--  -->
                        <template slot="SN" slot-scope="row0">
                            <span>{{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}</span>
                        </template>

                        <template slot="lom_is_active" slot-scope="row10">

                            <div :id="'row' + row10.item.booking_id">
                                <md-switch v-if="
                                    $sessionsStorage.get('designation') == 'Admin' &&
                                    $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                                    :id="'approval' + row10.item.booking_id" name="approval" class="md-primary"
                                    :value="row10.item.lom_is_active == 1 ? true : false"
                                    @change="activateLedger(row10.item)">
                                    <h6>
                                        <br />
                                        <b-badge :variant="row10.item.lom_is_active == 1 ? 'success' : 'danger'">
                                            {{ row10.item.lom_is_active == 1 ? 'Active' : 'In-ACtive' }}</b-badge>
                                    </h6>
                                </md-switch>
                            </div>
                        </template>

                    </b-table>

                </div>
            </div>

            <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
        </b-card>
    </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE_DOC } from "../../helper/constant.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection.js";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import UpdateCBModal from '../Pendency/UpdateCBModal.vue';
import ClientUserService from "../../services/ClientUserService.js";

export default {
    beforeMount() {
        this.$store.dispatch(
            "common/setAllClientList",
            JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
        );
        this.initializePage();
    },
    filters: {
        moment(date) {
            return DateFormat(date);
        },
    },
    data() {
        return {
            isModalOpen: false,

            visible: false,
            isLoading: false,
            totalRows: 0,
            currentPage: 1,
            perPage: 50,
            pageOptions: [100, 200, 300],
            filter: null,
            docURL: URL_BASE_DOC,
            ExcelBtnName: "Export As Excel",
            Filter: {
                lom_idsArr:[],
                userFilter: "",
                lomInvNoFilter: "",
                lom_ledger_nameFilter: "",
                lom_doc_typeFilter: "",
                lom_gst_noFilter: "",
                lom_pan_noFilter: "",
                lom_comp_nameFilter: "",
                lom_ref_typeFilter: "",
                lom_reference_noFilter: "",
                lom_doc_dateFilter: "",
                isActiveFilter: "1",
                commonFilter: "",
                clientIdFilter: "",
                createdAtRange: {
                    startDate: "",
                    endDate: "",
                },
                startDate: "",
                endDate: "",

            },

            columnMain: this.initializeColumns(),
            OutstandingList: [],
            lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
            debounce: null, // Debounce timer
            pagination: {
                currentPage: 1,
                perPage: 50,
                pageOptions: [5, 10, 15],
            },

            listStatus: [
                { label: "Active", value: 1 },
                { label: "In-Active", value: 0 },
            ],
            lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

            value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
            value2: [],
            langType: {
                pickers: ["Today", "Yesterday", "This Month", "This Year"],
            },
            time: "",
            date: "",
            week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

            langEnq: {
                pickers: ["", "", "previous 7 days", "previous 30 days"],
            },
            openLeft: "left",
            showCal: false,
            startDate: "2017-09-05",
            endDate: "2017-09-15",
            createdAtRange: {
                startDate: "",
                endDate: "",
            },
            locale: {
                direction: "ltr",
                format: "mm/dd/yyyy",
                separator: " - ",
                applyLabel: "Apply",
                cancelLabel: "Cancel",
                weekLabel: "W",
                customRangeLabel: "Custom Range",
                daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                monthNames: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ],
                firstDay: 0,
            },
            alert: {
                content: "Are you sure you want to delete ..!",
                ok: "ok",
            },
            generateExcel:0,
        };
    },
    computed: {

    },
    components: {
        userBasedClient,
        ModelListSelect,
        CustomLoader,

        DatePicker,
        DateRangePicker,

        MultiSelect,
        Multiselect,
    },

    methods: {
        activateLedger(item, index) {
            this.itemObj = item;
            this.indexNew = index;

            this.itemObj.lom_is_active = this.itemObj.lom_is_active == 1 ? 0 : 1;
            let paylod = {
                tableName: "ledger_outstanding_master",
                tableId: "lom_id",
                tableIsActive: "lom_is_active",
                value1: this.itemObj.lom_is_active,
                tableVal: item.lom_id,
                isMailSend: "No",
                manual: "No",
            };

            ClientUserService.getAllActive(JSON.stringify(paylod))
                .then((response) => {
                    const { data, status, statusText } = response;
                    if (status == 200 && data) {
                        this.getOutstandingList("Normal", "0", "0", "1", "1");
                    }

                })
                .catch((error) => {
                    console.log("Catch on Proforma Error: ", error);
                });
        },


        getCurrentLastDate() {
            var today = new Date();
            var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
            var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            var firstDay_mm = String("04").padStart(2, "0"); //January is 0!
            var firstDay_yyyy = firstDay.getFullYear();

            var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            var lastDay_yyyy = lastDay.getFullYear();

            firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
            lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();
            today = yyyy + "/" + mm + "/" + dd; //2018-06-01
            this.startDate = today;
            this.Filter.createdAtRange = {
                startDate: firstDay,
                endDate: lastDay,
            };
            this.getOutstandingList("Normal", "0", "0", "1", "1");
        },
        clearFilter() {
            this.Filter = {
                lom_idsArr:[],
                userFilter: "",
                lomInvNoFilter: "",
                lom_ledger_nameFilter: "",
                lom_doc_typeFilter: "",
                lom_gst_noFilter: "",
                lom_pan_noFilter: "",
                lom_comp_nameFilter: "",
                lom_ref_typeFilter: "",
                lom_reference_noFilter: "",
                lom_doc_dateFilter: "",
                isActiveFilter: "1",
                commonFilter: "",
                clientIdFilter: "",
                createdAtRange: {
                    startDate: "",
                    endDate: "",
                },
                startDate: "",
                endDate: "",
                isAllNo: 0,
                isSelectedColumn: 0,
            };
            this.getOutstandingList("Normal", "0", "0", "1", "1");
        },

        BranchBtnFilter(type) {

            this.getOutstandingList("Normal", "0", "0", "1", "1");
        },
        filterClear() {
            this.Filter = {
                lom_idsArr:[],
                userFilter: "",
                lomInvNoFilter: "",
                lom_ledger_nameFilter: "",
                lom_doc_typeFilter: "",
                lom_gst_noFilter: "",
                lom_pan_noFilter: "",
                lom_comp_nameFilter: "",
                lom_ref_typeFilter: "",
                lom_reference_noFilter: "",
                lom_doc_dateFilter: "",
                isActiveFilter: "1",
                commonFilter: "",
                clientIdFilter: "",
            };
        },

        initializePage() {
            this.getCurrentLastDate();
            lastVisitPage(this.$router.history.current.fullPath);
            const loginId = this.$sessionsStorage.get("loginId");
            if (!loginId) return this.$router.push({ path: "/Login/" });

            this.$store.dispatch("setCurrentRoute", this.$route.path);
            if (globalPermissionStatus("Sea Freight")) {
                this.getOutstandingList("Normal", "0", "0", "1", "1");
            } else {
                this.$router.push({ path: "/dashboard" });
            }

            this.$store.dispatch("common/setAllUserList", JSON.stringify({ itemCode: "GET_USERLIST_Data" }));
        },

        initializeColumns() {
            return [
                { key: "SN", mainkey: "SN", label: "SN.", sortable: true, table: "HJ." },
                // New columns based on the JSON data
                { key: "lom_inv_no", mainkey: "lom_inv_no", label: "Invoice No", sortable: true, table: "M." },
                { key: "lom_reference_no", mainkey: "lom_reference_no", label: "Reference No", sortable: true, table: "M." },
                { key: "lom_doc_type", mainkey: "lom_doc_type", label: "Doc Type", sortable: true, table: "M." },
                { key: "lom_ledger_name", mainkey: "lom_ledger_name", label: "Ledger Name", sortable: true, table: "M." },
                { key: "lom_gst_no", mainkey: "lom_gst_no", label: "GST No", sortable: true, table: "M." },
                { key: "lom_pan_no", mainkey: "lom_pan_no", label: "PAN No", sortable: true, table: "M." },
                { key: "lom_pay_amt", mainkey: "lom_pay_amt", label: "Payment Amount", sortable: true, table: "M." },
                { key: "lom_pending_amt", mainkey: "lom_pending_amt", label: "Pending Amount", sortable: true, table: "M." },
                { key: "lom_doc_status", mainkey: "lom_doc_status", label: "Doc Status", sortable: true, table: "M." },
                { key: "lom_is_active", mainkey: "lom_is_active", label: "Active", sortable: true, table: "M." },

            ];
        },
        debounceSearch() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => this.getOutstandingList("Normal", "0", "0", "1", "1"), 500);
        },
        getReports(id, btnName) {
            this.isLoading = true;
            this.generateExcel = "1";
            this.ExcelBtnName = "Downloading Please Wait .....";
            this.getOutstandingList("Excell", "0", "0", "1", "1");
        },
        fetchLastPage(event) {
            let CURRENT = 0;
            if (event == "1") {
                CURRENT = 0;
            } else {
                CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
            }
            this.getOutstandingList("Normal", "0", CURRENT, "2", event);
        },
        onPageChange: function (event) {
            // console.log("event=>", event);
            this.pagination.currentPage = event;
            this.$sessionsStorage.set("lastVisitPage", event);
            this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
            let CURRENT = 0;
            if (event == "1") {
                CURRENT = 0;
            } else {
                CURRENT = event * this.pagination.perPage - this.pagination.perPage;
            }
            this.getOutstandingList("Normal", "0", CURRENT, "2", event);
        },
        getOutstandingList(type, filterId, currentPage, searchType, pageNumber) {
            this.totalData = 0;
            this.OutstandingList = [];
            let payload = {};
            if (type == "Normal") {
                this.isLoading = true;
            }
            payload = {
                itemCode: "getBookingResp",
                type: type,
                currentPage: this.pagination.currentPage,
                page: this.pagination.currentPage,
                perPage: this.pagination.perPage,
                pageSize: this.pagination.perPage,
                generateExcel: this.generateExcel,
                record_type: "",
                isAllNo: this.generateExcel == '1' ? 1 : 0,
                isSelectedColumn: 0,
                lomInvNoFilter:this.Filter.lomInvNoFilter,
                lom_ledger_nameFilter:this.Filter.lom_ledger_nameFilter,
                lom_doc_typeFilter:this.Filter.lom_doc_typeFilter,
                lom_gst_noFilter:this.Filter.lom_gst_noFilter,
                lom_pan_noFilter:this.Filter.lom_pan_noFilter,
                lom_comp_nameFilter:this.Filter.lom_comp_nameFilter,
                lom_ref_typeFilter:this.Filter.lom_ref_typeFilter,
                lom_reference_noFilter:this.Filter.lom_reference_noFilter,
                lom_doc_dateFilter:this.Filter.lom_doc_dateFilter,
                isActiveFilter:this.Filter.isActiveFilter,
                commonFilter:this.Filter.commonFilter,
                startDate:this.Filter.createdAtRange.startDate,
                endDate:this.Filter.createdAtRange.endDate,
                lom_idsArr:this.Filter.lom_idsArr,
            };
            // Set responseType to 'blob' if generating Excel
            const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
            NodeLockPannelService.getAllOutstandingList(payload, config)
                .then((response) => {
                    const { data, status, statusText } = response;
                    // console.log("data PS=>", data.data);

                    if (status == 200 && data) {
                        if (this.generateExcel == "1") {

                            const blob = new Blob([data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", "get-outstanding-report.xlsx"); // Specify the file name
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            this.ExcelBtnName = "Export As Excel";
                            this.generateExcel = "0";
                            this.getOutstandingList("Normal", "0", "0", "1", "1");
                        } else {
                            if (data.data.length > 0) {
                                this.totalData = data.pagination.totalLedgerOutstandings;
                                this.OutstandingList = data.data;
                            }
                        }
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log("Catch on getOutstandingList Error: ", error);
                });
        },
        onFiltered(filtered) {
            this.totalRows = filtered.length;
            this.pagination.currentPage = 1;
        },
        goBack() {
            window.history.go(-1);
        },

        clearSearchFilter() {
            this.filter = "";
            this.getOutstandingList("Normal", "0", "0", "1", "1");
        },
        shouldBlink: function (item) {
            return item.CustomColorColumn === "red";
        },
        isBlinking: function (item) {
            return item.CustomColorColumn === "red";
        },
    },
};
</script>

<style>
.colwidth {
    min-width: 200px !important;
}

a:not(.md-button):not(.md-bottom-bar-item):hover {
    text-decoration: none !important;
}

.status-alerts {
    font-size: 11px;
    /* display: flex; */
    flex-direction: column;
    /* margin-bottom: 20px; */
}

@keyframes blinker {
    50% {
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// outstanding.vue?8ee48520